import React__default from 'react';
import { useGetCLByPrescription } from './api/use-get-cl-by-prescription.js';
import { mapClientToServerPrescription } from './api/mappers/client-to-server/map-client-to-server-prescription.js';
import { useCLEcommContext } from '../context/CLEcommContext.js';
import { useContactLensProductData } from '../../../../context/product-context-hooks.js';
import { isNonRecoverableError } from '../../../../types/typeguards.js';

const useFetchCLByPrescription = ({ eyeSide  })=>{
    const { actions , maxOrderableQuantity , triggerToastMessage  } = useCLEcommContext();
    const { product: { productMasterKey  } , activeVariant: { masterVariantSku , sku  } ,  } = useContactLensProductData();
    const onSuccess = React__default.useCallback((result)=>{
        const { prescriptionCLProduct  } = result;
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            prescriptionCLProduct
        });
    }, []);
    const onError = React__default.useCallback((result)=>{
        actions.updateQueryResult({
            eyeSide,
            maxOrderableQuantity,
            error: result.error
        });
        if (isNonRecoverableError(result.error)) {
            triggerToastMessage('non-recoverable-error');
        }
    }, []);
    const getCLByPrescription = useGetCLByPrescription({
        onSuccess,
        onError
    });
    const fetchCLByPrescription = React__default.useCallback((columnConfigurations)=>{
        const prescription = mapClientToServerPrescription(columnConfigurations);
        if (!masterVariantSku && !productMasterKey) {
            console.error(`Cannot call getCLByPrescription for Contact Lens with sku: ${sku}. The masterVariantSku and productMasterKey are both invalid.`);
            return;
        }
        if (prescription) {
            actions.setQueryLoading({
                eyeSide,
                loading: true
            });
            if (!!masterVariantSku) {
                getCLByPrescription({
                    masterVariantSku,
                    prescription
                });
            } else {
                // TODO:CXRO-1356 - remove this else case. The opco MUST add the masterVariantSku to the variant to enable multivariant features
                // such as multivariant Color or Lenses Per Box. If not, quering by productMasterKey will always find more than one variant, and therefore fail.
                getCLByPrescription({
                    brandKey: productMasterKey,
                    prescription
                });
            }
        }
    }, [
        actions,
        productMasterKey,
        masterVariantSku,
        eyeSide,
        getCLByPrescription
    ]);
    return fetchCLByPrescription;
};

export { useFetchCLByPrescription };
//# sourceMappingURL=use-fetch-cl-by-prescription.js.map
